if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.mobileScrollFrame = null;
        this.mobileMedia = [];
        this.onMobileScroll = this.onMobileScroll.bind(this);
      }

      hide() {
        this.teardownMobileViewer();
        document.body.classList.remove('fwd-product-media-modal-open');
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const container = this.querySelector('[role="document"]');
        const requestedMediaId = this.openedBy.getAttribute('data-media-id');
        const mediaItems = Array.from(container.children).filter((element) => element.matches('[data-media-id]'));

        mediaItems.filter((element) => element.dataset.mediaId !== requestedMediaId).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = mediaItems.find((element) => element.dataset.mediaId === requestedMediaId) || mediaItems[0];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (this.mobileMediaQuery.matches) {
          document.body.classList.add('fwd-product-media-modal-open');
          this.setupMobileViewer(container, activeMedia);
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      setupMobileViewer(container, activeMedia) {
        this.teardownMobileViewer();
        this.mobileMediaContainer = container;
        this.mobileMedia = Array.from(container.children).filter(
          (element) => element.matches('[data-media-id]') && window.getComputedStyle(element).display !== 'none'
        );
        this.mobileCurrent = this.querySelector('[data-product-media-current]');
        this.mobileTotal = this.querySelector('[data-product-media-total]');
        if (this.mobileTotal) this.mobileTotal.textContent = String(this.mobileMedia.length);

        container.addEventListener('scroll', this.onMobileScroll, { passive: true });
        this.mobileScrollFrame = window.requestAnimationFrame(() => {
          this.mobileScrollFrame = null;
          container.scrollTo({ top: activeMedia.offsetTop, behavior: 'auto' });
          this.updateMobileCounter(activeMedia);
        });
      }

      teardownMobileViewer() {
        if (this.mobileMediaContainer) {
          this.mobileMediaContainer.removeEventListener('scroll', this.onMobileScroll);
        }
        if (this.mobileScrollFrame !== null) {
          window.cancelAnimationFrame(this.mobileScrollFrame);
        }
        this.mobileMediaContainer = null;
        this.mobileScrollFrame = null;
        this.mobileMedia = [];
      }

      onMobileScroll() {
        if (this.mobileScrollFrame !== null) return;
        this.mobileScrollFrame = window.requestAnimationFrame(() => {
          this.mobileScrollFrame = null;
          if (!this.mobileMediaContainer || this.mobileMedia.length === 0) return;

          const containerRect = this.mobileMediaContainer.getBoundingClientRect();
          const viewportCenter = containerRect.top + containerRect.height / 2;
          const currentMedia = this.mobileMedia.reduce((nearest, media) => {
            const mediaRect = media.getBoundingClientRect();
            const distance = Math.abs(mediaRect.top + mediaRect.height / 2 - viewportCenter);
            return !nearest || distance < nearest.distance ? { media, distance } : nearest;
          }, null)?.media;

          this.updateMobileCounter(currentMedia);
        });
      }

      updateMobileCounter(media) {
        if (!media || !this.mobileCurrent) return;
        const currentIndex = this.mobileMedia.indexOf(media);
        if (currentIndex >= 0) this.mobileCurrent.textContent = String(currentIndex + 1);
      }
    }
  );
}
